export const OTHER_SEGMENT_VALUE = `$other_segment`;
